export function parseAffectedColumnsJson(raw: string | null | undefined): string[] {
  if (!raw || raw === 'null') {
    return [];
  }
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [raw];
  }
}

export function formatAuditDate(iso: string | undefined): string {
  if (!iso) {
    return '';
  }
  try {
    return new Date(iso).toLocaleString('es-CO', {
      dateStyle: 'short',
      timeStyle: 'medium',
    });
  } catch {
    return iso;
  }
}

export function getOperationKind(operation: number): 'create' | 'update' | 'delete' | 'unknown' {
  switch (operation) {
    case 0:
      return 'create';
    case 1:
      return 'update';
    case 2:
      return 'delete';
    default:
      return 'unknown';
  }
}
